<template>
  <div class="homeModule">
    <BlockLabel>
      <h2>{{ errMessage }}</h2>
    </BlockLabel>
    <div class="image"><img src="images/block.svg" /></div>
  </div>
</template>

<script>
import BlockLabel from '@/components/BlockLabel.vue';

export default {
  components: { BlockLabel },
  props: {
    errMessage: {
      type: String,
      default: 'Sorry your shift offer link has expired.',
    },
  },
  data() {
    return {};
  },
  computed: {
    // ...mapGetters(['']),  // if using vuex uncomment this
    // ...mapState(['']),  // if using vuex uncomment this
  },
  methods: {
    // ...mapActions(['']),  // if using vuex uncomment this
  },
};
</script>

<style scoped>
.homeModule {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  max-width: 430px; /* keep mobile width */
  padding: 1rem;
  height: 100%;
}
img {
  max-height: 300px;
}
.image {
  margin: 50px 0;
}
h2 {
  font-weight: 700;
}
.image img {
  max-height: 300px;
}
</style>
